import(/* webpackMode: "eager" */ "/workspace/app/author-books/components/Products.jsx")